function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { useTheme } from "../useTheme/useTheme";
export function withTheme(WrappedComponent) {
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var ComponentWithTheme = function(props) {
        var theme = useTheme();
        return _jsx(WrappedComponent, _objectSpread({}, props, {
            theme: theme
        }));
    };
    ComponentWithTheme.displayName = "withTheme(".concat(displayName, ")");
    return ComponentWithTheme;
}
export default withTheme;
